module.exports = __webpack_public_path__ + "img/Joinus.78656811.png";